import { IInterval } from "../../../../Context/Interval";
import { ISystemContext } from "../../../../Context/SystemContext";
import { PixiSpriteResource } from "../../../../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { CanvasSprite } from "../../../../slot/Sprite/CanvasSprite";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { LogGroup, CreateElement, Scale, Size } from "../../../.././MyHelpers";
import { Slide, SlideFactory2Params } from "./Slide";
import { Settings, JackpotDisplayType } from "../../../../Settings";
import { ITranslatedCanvasParams, TranslatedCanvasSprite } from "../../../TranslatedCanvasSprite";

export class HoldAndSpinRight extends Slide {
	protected logGroup: LogGroup;
	protected resid: ResourceIdentifier;
	protected systemContext: ISystemContext;

    protected SripiteTimer: IInterval;
    protected SpriteRigth: CanvasSprite = null;

    protected SripiteTimerRight: IInterval;

    protected stickySpinRightSpriteTranslator : TranslatedCanvasSprite = null;

    constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize : Size) {
        super(initData, p , viewSize );

		
		this.logGroup = 	 this.p.logGroup.Add("HoldAndSpinRight");
		this.resid = 		 this.p.resid.Add("HoldAndSpinRight");
		this.systemContext = this.p.systemContext.CreateSubContext("HoldAndSpinRight");
        this.viewSize = viewSize;

        this.view = CreateElement("div", {
            classes: ["HoldAndSpinRight", this.resid.Scope()],
            style: {
                position: "absolute",
                height: viewSize.Height+"px",
                width: viewSize.Width+"px",
                display: "flex",
                flexDirection: "column",
                flexShrink: "0",
            }
        });
        let ChangeFilepath = this.path + "Slider2/StickySpinRight-"+Settings.JackpotDisplayType.toString();

        let params : ITranslatedCanvasParams ={
            resid : this.resid,
            path : ChangeFilepath,
            logGroup : this.logGroup,
            viewSize : this.viewSize,
            nameSpriteSlide : "StickySpinRight",
            translator : this.translator,
        }
        this.stickySpinRightSpriteTranslator = new TranslatedCanvasSprite(params);
    }


    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        this.stickySpinRightSpriteTranslator.PrepareResources(resourceManager);
    }   

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        this.stickySpinRightSpriteTranslator.ResourcesLoaded(resourceManager);
		this.view.appendChild(this.stickySpinRightSpriteTranslator.View());     
        this.SripiteTimerRight = this.systemContext.TimingContext().CreateInterval("StickySpinRight", this.nextAnimInterval, () => this.stickySpinRightSpriteTranslator.Start());
    }



    public override View(): HTMLElement {
        return this.view;
    }
    public override Update() {

        //this.SpriteRigth.Update();
        this.stickySpinRightSpriteTranslator.Update();
    }
    public override Start() {

        this.SripiteTimerRight.Start();
    }

    public override Stop() {

		this.SripiteTimerRight.Stop();
		//this.SpriteRigth.StopAndReset();

    }
}
